import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useDispatchAction from "@/hooks/useDisptachAction";
import { setUserInfo } from "@/redux/actions/home";
import { APIGetUserInfo } from "@/api";


const useLogin = () => {

  const userInfo = useSelector(state => state.home.userInfo.userInfo);

  const [loginModalShow, setLoginModalShow] = useState(false);

  const dispatchAction = useDispatchAction({ setUserInfo });

  const getUserInfo = () => {
    const token = localStorage.getItem("token");
    if (token) {
      APIGetUserInfo().then(resp => {
        if (resp.data.user) {
          const user = resp.data.user;
          dispatchAction.setUserInfo(user);
          localStorage.setItem("user", JSON.stringify(user));
        }
      });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoginModalShow(true);
    }
  }, []);

  return {
    needLogin: !userInfo?.displayName,
    loginModalShow,
    getUserInfo,
  };

};

export default useLogin;
